import { WSConnection, WsConnectionStatus } from '@hakimo-ui/hakimo/types';
import { createContext, useContext } from 'react';

const defaultValue: WSConnection = {
  connectionState: {
    status: WsConnectionStatus.PENDING,
    isDuplicateSession: false,
  },
};

export const AlarmDetailWsContext = createContext(defaultValue);

export function useAlarmDetailWs() {
  const httpClient = useContext(AlarmDetailWsContext);
  return httpClient;
}
